import { connect } from 'react-redux';
import Highlighter from 'react-highlight-words';
import { decode as base64_decode } from 'base-64';
import { SearchOutlined } from '@ant-design/icons';
import { constant } from '../../../Utils/constants';
import TableSelect from '../../../Widgets/TableSelect';
import React, { useEffect, useRef, useState } from 'react';
import InputComponent from '../../../Widgets/InputComponent';
import {
  Form,
  message,
  Select,
  Modal,
  Space,
  Input,
  Button
} from 'antd';
import {
  getDeviceTypeData,
  _getUOMList,
  tagCreateAPI,
  // deleteTags,
  getTagsByEquipmentTypeId,
  getDeviceTypeById,
  tagUpdateAPI
} from '../../../Utils/FormCalls';
import {
  StyledSubHeading,
} from '../../../CSS/style';

const { Option } = Select;

const EquipmentTagDetails = (props) => {
  const [searchText, setSearchText] = useState([]);
  const [formObject, setFormObject] = useState(props.formObject || {});
  const [datasource, setDatasource] = useState([{}]);
  const [visible, setVisible] = useState(false);
  const [UOMList, setUOMList] = useState([]);
  const TagsRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      try {
        await _getDataById(); // Assuming this is defined elsewhere
        let updatedFormObject = {
          ...formObject,
          // equipmentName: selectedDevice && selectedDevice[0] && selectedDevice[0]['DeviceCode']
        };
        setFormObject(updatedFormObject);
        if (TagsRef.current) {
          TagsRef.current.setFieldsValue(updatedFormObject);
        }
      } catch (error) {
        message.warning(`${error.message}`);
      }

      try {
        const UOMListData = await _getUOMList();
        setUOMList(UOMListData);
      } catch (error) {
        message.warning(`${error.message}`);
      }
    };

    fetchData();
  }, []); // Empty dependency array means this runs once on mount

  useEffect(() => {

    if (props.formObject && Object.keys(props.formObject).length === 0 && Object.keys(formObject).length === 0) {
      handleReset(); // Assuming this is defined elsewhere
    }

    if (props.formObject && Object.keys(props.formObject).length === 0) {
      if (TagsRef.current) {
        TagsRef.current.setFieldsValue(props.formObject);
      }
    }

    if (props.formObject !== formObject) {
      setFormObject(props.formObject);
      setDatasource(
        props.formObject && props.formObject.Specifications
          ? props.formObject.Specifications
          : [{}]
      );
    }
  }, [props.formObject]);


  const onDrawerCancel = (e) => {
    if (e.target.tagName === 'DIV') {
      e.preventDefault();
      return message.error(`Please Click On Cancel`);
    } else {
      setVisible(false);
    }
  };

  const onModalOk = () => {
    setVisible(false);
  };


  const _getDataById = async () => {
    let updatedFormObject = {};
    let path = props.location.pathname.split('/rubus/AMM/EquipmentTagDetails/');
    let formId = base64_decode(path[1]);
    if (formId !== 'new') {
      let deviceType = await getDeviceTypeById(formId);
      let Tags = await getTagsByEquipmentTypeId(deviceType[0].Code);
      updatedFormObject = {
        ...(deviceType && Array.isArray(deviceType) && deviceType[0] ? deviceType[0] : {}),
        Tags: Tags && Array.isArray(Tags) ? Tags : []
      };
    }
    if (TagsRef.current) {
      TagsRef.current.setFieldsValue(updatedFormObject);
    }
    setFormObject(updatedFormObject);
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm(); // Close the filter dropdown
    setSearchText(selectedKeys[0]); // Set the search text state
  };

  const handleReset = (clearFilters, confirm) => {
    clearFilters(); // Clear the filters applied to the table
    setSearchText(''); // Reset the search text state
    confirm(); // Close the filter dropdown
  };

  const onSubmit = async (i) => {
    let updatedFormObject = TagsRef.current.getFieldsValue();
    let payload = {
      ...(updatedFormObject && updatedFormObject['Tags'][i]),
      DeviceType: updatedFormObject['Code']
    };
    let statusResponse = payload && payload.Id ? await tagUpdateAPI(payload) : await tagCreateAPI(payload);
    if (statusResponse && statusResponse.message) {
      message.success(statusResponse.message);
    } else if (statusResponse && statusResponse.Error) {
      message.error(statusResponse.Error);
    }
  };

  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          placeholder={constant.search}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm)}
          style={{ width: 188, marginBottom: 8, display: 'block' }}
        />
        <Button
          onClick={() => handleSearch(selectedKeys, confirm)}
          icon={<SearchOutlined />}
          
          style={{ width: 90, marginRight: 8 }}
        >
          {constant.search}
        </Button>
        <Button
          danger
          onClick={() => handleReset(clearFilters, confirm)}
          
          style={{ width: 90 }}
        >
          {constant.Reset}
        </Button>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined, }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex] && record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    onFilterDropdownOpenChange: (visible) => {
      if (visible) {
        setTimeout(() => this.searchInput.select());
      }
    },
    render: (text) => (
      <Highlighter
        highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
        searchWords={[searchText]}
        autoEscape
        textToHighlight={text && text.toString()}
      />
    )
  });

  const TableDropdownChange = async (value) => {
    let updatedFormObject = TagsRef.current.getFieldsValue();
    try {
      let deviceTypeData = await getDeviceTypeData(value['DeviceType']);
      updatedFormObject = {
        ...updatedFormObject,
        equipmentName: value.Name,
        Name: deviceTypeData[0].Name,
        Code: deviceTypeData[0].Code,
        Description: deviceTypeData[0].Description
      };
      TagsRef.current.setFieldsValue(updatedFormObject);
      setFormObject(updatedFormObject);
      setVisible(false);
    } catch (error) {
      message.warning(`${error.message}`);
    }
  };

  return (
    <>
      <Form
        name="EquipmentTags"
        ref={TagsRef}
        className="collapse"
        onFinish={onSubmit}
        onKeyDown={(e) => {
          e.key === 'Enter' && e.preventDefault();
        }}
        initialValues={formObject}
        layout="horizontal"
        labelCol={{ flex: '130px' }}
        labelAlign="right"
        labelWrap
        validateMessages={{
          required: '${label} is required!',
          types: {
            email: '${label} is not a valid email!',
            number: '${label} is not a valid number!'
          },
          number: {
            range: '${label} must be between ${min} and ${max}'
          },
          pattern: {
            mismatch: '${label} does not match pattern'
          }
        }}
      >
        <div style={{ display: 'flex', flexWrap: 'wrap' }}>
          <Form.Item name="Id"></Form.Item>
          <Modal
            open={visible}
            width={800}
            closable
            title={constant.selectEquipment}
            onOk={onModalOk}
            onCancel={onDrawerCancel}
          >
            <TableSelect
              data={datasource}
              translationCache={props.translationCache}
              key="Equipment"
              columns={[
                {
                  title: constant.equipment,
                  dataIndex: 'DeviceCode',
                  key: 'DeviceCode',
                  ...getColumnSearchProps('DeviceCode')
                },
                {
                  title: constant.equipmentDescription,
                  dataIndex: 'Name',
                  key: 'Name',
                  ...getColumnSearchProps('Name')
                }
              ]}
              handleDropdownChange={TableDropdownChange}
            />
          </Modal>
          <Form.Item
            style={{ width: '100%', flex: '50%' }}
            label={constant.equipmentTypeName}
            name="Name"
          >
            <InputComponent
              style={{ width: '70%' }}
              disabled={formObject && formObject.Id ? true : false}
              placeholder={constant.inputEquipmentTypeName}
            />
          </Form.Item>
          <Form.Item
            style={{ width: '100%', flex: '50%' }}
            label={constant.equipmentTypeCode}
            name="Code"
          >
            <InputComponent
              disabled={formObject && formObject.Id ? true : false}
              style={{ width: '70%' }}
              placeholder={constant.inputEquipmentTypeCode}
            />
          </Form.Item>
          <Form.Item
            style={{ width: '100%', flex: '50%' }}
            name="Description"
            label={constant.equipmentTypeDescription}
          >
            <InputComponent
              disabled={formObject && formObject.Id ? true : false}
              style={{ width: '70%' }}
              placeholder={constant.equipmentTypeDescription}
            />
          </Form.Item>
        </div>

        <StyledSubHeading>
          {constant.equipmentTags}
        </StyledSubHeading>
        <div style={{ margin: '20px 0px' }}>
          <Form.Item>
            <Form.List name="Tags">
              {(fields, { add }) => (
                <>
                  <div style={{ display: 'flex', flexWrap: 'wrap', marginLeft: '40px' }}>
                    {fields.map(({ key, name, ...restField }) => (
                      <Space
                        key={key}
                        style={{
                          display: 'flex'
                        }}
                        align="baseline"
                      >
                        <Form.Item
                          {...restField}
                          name={[name, 'Name']}
                          rules={[
                            {
                              required: true,
                              message: 'Name is required!'
                            }
                          ]}
                        >
                          <InputComponent placeholder='Name' />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'Code']}
                          rules={[
                            {
                              required: true,
                              message: 'Code is required!'
                            }
                          ]}
                        >
                          <InputComponent placeholder='Code' />
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'UOM']}
                          rules={[
                            {
                              required: true,
                              message: 'UOM is required!'
                            }
                          ]}
                        >
                          <Select
                            showArrow
                            showSearch
                            openOnFocus
                            style={{ width: 160 }}
                            placeholder='UOM'
                            filterOption={(input, option) =>
                              option.props.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            {UOMList.map((uom, index) => (
                              <Option key={index} value={uom.UOM}>
                                {uom.UOM}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                        <Form.Item
                          {...restField}
                          name={[name, 'DataType']}
                          rules={[
                            {
                              required: true,
                              message: 'DataType is required!'
                            }
                          ]}
                        >
                          <Select
                            openOnFocus
                            style={{ width: 160 }}
                            placeholder='DataType'
                          >
                            <Option value="float">float</Option>
                            <Option value="boolean">boolean</Option>
                          </Select>
                        </Form.Item>
                        <Form.Item>
                          <Button
                            onClick={() => onSubmit(name)}
                          >
                            Submit
                          </Button>
                        </Form.Item>
                      </Space>
                    ))}
                  </div>
                  <Form.Item>
                    <Button
                      style={{ width: '150px', marginLeft: '40px' }}
                      onClick={() => add()}
                      block
                    >
                      Add Parameters
                    </Button>
                  </Form.Item>
                </>
              )}
            </Form.List>
          </Form.Item>
        </div>
      </Form>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    translationCache: state.TranslationReducer.translationCache,
  };
};

export default connect(mapStateToProps)(EquipmentTagDetails);